import Pagamenti from './Pagamenti';
export default Pagamenti;
